import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {
  PASSWORD_REQUIREMENTS_HINT,
  PasswordStrengthFailures,
} from '../../validators/password.validator';

@Component({
  selector: 'app-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PasswordInputComponent),
      multi: true
    }
  ]
})
export class PasswordInputComponent implements ControlValueAccessor, OnInit {
  ngOnInit(): void {

  }
  writeValue(obj: any): void {

  }
  registerOnChange(fn: any): void {

  }
  registerOnTouched(fn: any): void {

  }
  setDisabledState?(isDisabled: boolean): void {

  }
  @Input() submitted: boolean;
  @Input() formControl: FormControl;
  @Input() placeHolder: string = 'Enter a password';
  /**
   * Shows the policy hint under the field. Off by default so sign-in - which
   * only checks that SOMETHING was typed - never advertises strength rules that
   * would wrongly imply an existing account password is invalid.
   */
  @Input() showRequirements = false;
  readonly requirementsHint = PASSWORD_REQUIREMENTS_HINT;
  fieldTextType: boolean;

  /**
   * Errors are revealed once the user has left the field or submitted, rather
   * than on the first keystroke, so a half-typed password isn't scolded. The
   * always-visible hint above covers them before they start.
   */
  get showErrors(): boolean {
    return !!(this.submitted || this.formControl?.touched) && !!this.formControl?.errors;
  }

  /** Per-rule flags from passwordValidator, or null when strength isn't the failure. */
  get strengthFailures(): PasswordStrengthFailures | null {
    const e = this.formControl?.errors?.['passwordStrength'];
    return e && typeof e === 'object' ? e : null;
  }

  onChange: (value: any) => void = () => { };
  onTouched: () => void = () => { };

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  clearInput() {
    this.formControl.setValue('');
  }

}
